import getConfig from "next/config";
import merge from "deepmerge";
const {
  serverRuntimeConfig,
  publicRuntimeConfig
} = getConfig();
const config = merge(serverRuntimeConfig, publicRuntimeConfig);
export default config;
export function getStoreId() {
  return config.storeId["vod"];
}